import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SampleInspection } from './extras/sample-inspection.interceptor';
import { SettingService } from './services/setting.service';
import { FeatureService } from './services/feature.service';
import { environment } from '../environments/environment';
import { installModalBackdropGuard } from './extras/modal-backdrop-guard';

@Component({
    selector: 'abe-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'web-admin';
    favIcon: HTMLLinkElement = document.querySelector('#appIcon');

    constructor(
        private settingService: SettingService,
        private features: FeatureService,
        router: Router,
    ) {
        // Sample mode follows the page being opened, before its guards and requests run.
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                SampleInspection.active = SampleInspection.isSampleUrl(event.url);
            }
        });
    }

    ngOnInit() {
        // Turns on the Inspectmite UI (assets/im-ui/*.css is scoped to body.im).
        document.body.classList.add('im');
        // Dragging a text selection out of a modal must not close it (see modal-backdrop-guard.ts).
        installModalBackdropGuard();
        this.settingService.getSettingData().subscribe(
            data => {
                this.favIcon.href = environment.doSpace + '/media/logo/0/' + data.settings_favicon_image;
            }
        );

        // Always refresh feature flags on app boot when there's an active
        // session — covers page reloads (where login flow doesn't re-fire)
        // and ensures admin preset changes land within one reload.
        if (localStorage.getItem('app_token')) {
            this.features.refresh().subscribe();
        }
    }
}
